import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../../components/Pagination";
import { unitConstModel } from "../../../constant/ConstantList";

import moment from "moment";

const FarmerBalanceForm = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  console.log("loginUserId", loginUserId);
  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const { sendRequest: getFarmerData } = useHttp();

  const getFarmers = () => {
    getFarmerData(
      {
        url: `/api/autoFillFarmerIdNo/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setFarmerData(res);
        }
      }
    );
  };

  useEffect(() => {
    getFarmers();
  }, [getFarmerData]);

  const [data, setData] = useState([]);
  const [formData, setFormData] = useState();
  const [farmerData, setFarmerData] = useState([]);

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "", // This ensures empty cells are shown as empty strings
    });

    const headers = parsedData[0];

    const jsonData = parsedData?.slice(1).map((row) => {
      const farmerNo = row[headers.indexOf("Farmer No")];
      const identificationNo = row[headers.indexOf("Identification No")];

      const matchingFarmer = farmerData.find(
        (farmer) =>
    
          farmer.identificationNo ==identificationNo
      );
      console.log("match farmer",matchingFarmer);
      
      const stock = {
        farmerId: matchingFarmer ? matchingFarmer.farmerId : "",

        serviceId: serviceId,
        amountBalance: row[headers.indexOf("Amount Balance")],
        typeOfBalance: row[headers.indexOf("Type of Balance")],

        status: 1,
        createdBy: localStorage.getItem("id"),
        createdDate: moment().format("DD/MM/YYYY"),
        orgId: localStorage.getItem("orgId") || 2,
      };

      return stock;
    });

    console.log("jsonData", jsonData);

    setData(parsedData);
    setFormData(jsonData);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: postFarmerBalance } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postFarmerBalance(
      {
        url: "/api/farmerOpeningBalances/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Farmer Balance Added  Successfully`);
        props.addForm(false);
        setFormData("");
        setData("");
      }
    );
  };

  return (
    <>
      {" "}
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <form onSubmit={submitHandler}>
                  <div className="card mt-2">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-9">
                          {" "}
                          <label className="card-title">
                            Farmer Balance Details
                          </label>
                        </div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                        <div className="col-1 text-right">
                          <button
                            type="button"
                            className="btn btn-tool"
                            data-card-widget="remove"
                            onClick={() => props.addForm(false)}
                          >
                            <i className="fas fa-times" />
                          </button>
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {currentItems[0] &&
                                currentItems[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems &&
                              currentItems.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      className="btn  btn-primary mx-2 my-2"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerBalanceForm;
